import BaseRepository from '@/api/repositories/BaseRepository';

export default class CompanyVariablesRepository extends BaseRepository {
	getAll() {
		return this.get(`companyvariables`, {});
	}

	saveBatch(data) {
		return this.put(`companyvariables/batch`, {}, data);
	}
}
